import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "headerTop header-wrapper-default" }
const _hoisted_3 = { class: "headerBox" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://www.aowok.com/style/mock/logo.gif",
  style: {"width":"200px","height":"30px","margin":"8px 0px"},
  alt: "本真缘梦-以本我成就梦想",
  title: "本真缘梦-以本我成就梦想"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("nav", { class: "header-menu" }, null, -1)
const _hoisted_6 = { class: "header-user" }
const _hoisted_7 = {
  key: 0,
  class: "header-user-login"
}
const _hoisted_8 = {
  key: 1,
  class: "header-user-login"
}
const _hoisted_9 = {
  key: 0,
  src: "https://www.aowok.com/upload/img/assets/PurUser.jpg",
  class: "header-HeadPortrait"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = { style: {"font-size":"0.8rem","margin":"7px 4px 1px 4px"} }
const _hoisted_12 = { style: {"margin":"0"} }
const _hoisted_13 = {
  class: "home-container",
  style: {"display":"grid","margin":"0 auto","width":"100%","background-color":"#ece6f1"}
}
const _hoisted_14 = { class: "purContainer" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", {
  class: "SusBoxD4",
  id: "outTimer",
  style: {"writing-mode":"horizontal-tb"}
}, "on", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "SusBoxD3" }, "read", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "SusBoxD5" }, "you may also like...", -1)
const _hoisted_18 = [
  _hoisted_15,
  _hoisted_16,
  _hoisted_17
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_leftHome = _resolveComponent("v-leftHome")!
  const _component_a_drawer = _resolveComponent("a-drawer")!
  const _component_v_footerHome = _resolveComponent("v-footerHome")!
  const _component_v_GuestId = _resolveComponent("v-GuestId")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.$route.meta.keepAlive == true)
      ? (_openBlock(), _createElementBlock("header", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_router_link, {
                to: "/",
                class: "header-community-logo"
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }),
              (_ctx.userInfo != null)
                ? (_openBlock(), _createBlock(_component_a_col, {
                    key: 0,
                    class: "max640"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_6, [
                (_ctx.userInfo == null)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7))
                  : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createVNode(_component_a_row, { style: {"float":"right"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_col, null, {
                            default: _withCtx(() => [
                              (_ctx.userInfo.HeadPortrait == null)
                                ? (_openBlock(), _createElementBlock("img", _hoisted_9))
                                : _createCommentVNode("", true),
                              (_ctx.userInfo.HeadPortrait != null)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 1,
                                    src: 'https://www.aowok.com/upload/img/User/HeadPortrait/' + _ctx.userInfo.HeadPortrait,
                                    class: "header-HeadPortrait"
                                  }, null, 8, _hoisted_10))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_col, { style: {"line-height":"14px","margin":"0"} }, {
                            default: _withCtx(() => [
                              _createElementVNode("p", _hoisted_11, [
                                _createElementVNode("b", null, _toDisplayString(_ctx.userInfo.UserName.length>12?_ctx.userInfo.UserName.slice(0, 12)+"..":_ctx.userInfo.UserName), 1)
                              ]),
                              _createElementVNode("p", _hoisted_12, [
                                _createElementVNode("button", {
                                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.delteleToken())),
                                  class: "headerbntton"
                                }, "登出"),
                                _createElementVNode("button", {
                                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.gotoPurhome())),
                                  class: "headerbntton"
                                }, "服务")
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("main", _hoisted_13, [
      _createVNode(_component_a_row, { class: "purRow" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_14, [
            (_ctx.showPage)
              ? (_openBlock(), _createBlock(_component_router_view, { key: 0 }))
              : _createCommentVNode("", true)
          ]),
          (_ctx.$route.meta.keepLeft == true)
            ? (_openBlock(), _createBlock(_component_a_col, {
                key: 0,
                class: "purRight"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_leftHome, { userInfo: _ctx.userInfo }, null, 8, ["userInfo"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    (_ctx.$route.meta.keepAlive == true)
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          class: "drawer showRead bgCWhite",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showDrawer && _ctx.showDrawer(...args)))
        }, _hoisted_18))
      : _createCommentVNode("", true),
    (_ctx.$route.meta.keepAlive == true)
      ? (_openBlock(), _createBlock(_component_a_col, {
          key: 2,
          class: "purRight"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_drawer, {
              open: _ctx.homevisible,
              "onUpdate:open": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.homevisible) = $event)),
              class: "custom-class",
              style: {"color":"red"},
              title: "操作面板",
              placement: "right"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_leftHome, { userInfo: _ctx.userInfo }, null, 8, ["userInfo"])
              ]),
              _: 1
            }, 8, ["open"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.showPage &&_ctx.$route.meta.keepFooter == true)
      ? (_openBlock(), _createBlock(_component_v_footerHome, { key: 3 }))
      : _createCommentVNode("", true),
    (_ctx.showPage &&_ctx.$route.meta.keepGuestId == true)
      ? (_openBlock(), _createBlock(_component_v_GuestId, { key: 4 }))
      : _createCommentVNode("", true)
  ], 64))
}